<template>
  <VaccinationPage
    title="Diabetes"
    :buttons="buttons"
    baseRoute="/DiabetesSecondPage"
    :bottomImage="require('@/assets/page18/Asset 164.png')"
    :footerBanner="require('@/assets/page4/lowererPanner.png')"
    prevRoute="/vaccination"
    nextRoute="/DiabetesSecondPage"
  />
</template>

<script setup>
import VaccinationPage from "@/components/VaccinationPage.vue";

const buttons = [
  { imgPath: require("@/assets/page18/Asset 152.png"), name: "Influenza" },
  { imgPath: require("@/assets/page18/Asset 153.png"), name: "Pneumococcal" },
  { imgPath: require("@/assets/page18/Asset 154.png"), name: "RSV" },
  { imgPath: require("@/assets/page18/Asset 155.png"), name: "COVID-19" },
  { imgPath: require("@/assets/page18/Asset 156.png"), name: "HepatitisA" },
  { imgPath: require("@/assets/page18/Asset 157.png"), name: "HepatitisB" },
  { imgPath: require("@/assets/page18/Asset 158.png"), name: "Zoster" },
  { imgPath: require("@/assets/page18/Asset 159.png"), name: "MMR" },
  { imgPath: require("@/assets/page18/Asset 160.png"), name: "Varicella" },
  { imgPath: require("@/assets/page18/Asset 161.png"), name: "Tetanus" },
  { imgPath: require("@/assets/page18/Asset 162.png"), name: "MeningococcalMenB" },
  { imgPath: require("@/assets/page18/Asset 163.png"), name: "Humanpapilloma" },
];
</script>
